// Generated by ts-to-zod
import { z } from 'zod';

export const paginationQuerySchema = z.object({
  pageSize: z.number().optional(),
  page: z.number().optional(),
});
